import type { CurrentPlan } from '@/lib/api/types';

/** O gratuito em pt-BR: o catálogo o chama de "Free". */
const FREE_LABEL = 'Gratuito';

/**
 * Os status da assinatura em pt-BR, para o checkout, o cancelamento, a Visão
 * geral e a conta lerem o mesmo vocabulário. Uma chave nova do servidor aparece
 * como está, em vez de sumir da tela.
 */
export const BILLING_STATUS_LABEL: Record<string, string> = {
  free: FREE_LABEL,
  trialing: 'Trial ativo',
  active: 'Ativa',
  past_due: 'Pagamento em atraso',
  pending_payment: 'Aguardando pagamento',
  canceled: 'Cancelada',
};

/**
 * O plano da conta numa palavra, sob o primeiro nome na gaveta do celular (o
 * "Pro" do app do Gemini): "Gratuito" no plano gratuito e o nome do catálogo
 * ("Pro") com o plano pago valendo sem pendência, num trial ou numa assinatura
 * ativa. Em atraso, aguardando pagamento ou cancelada não há palavra que não
 * engane (o cartão "Plano" da Visão geral explica cada caso), e sem plano no /me
 * também não há linha.
 */
export function planLabel(plan?: Pick<CurrentPlan, 'name' | 'status'>): string | null {
  if (plan?.status === 'free') return FREE_LABEL;
  if (plan?.status === 'trialing' || plan?.status === 'active') return plan.name;
  return null;
}
